import * as React from 'react';

import { Text } from '../../Text';
import { ISuburbanInfoSchema } from '../../../repositories/favorites/entities/favorite_entity_for_desktop/SuburbanInfoSchema';

export interface ISuburbanInfoProps {
  suburbanInfo: ISuburbanInfoSchema;
}

export function SuburbanInfo({ suburbanInfo }: ISuburbanInfoProps) {
  const { areaText, rentTypeText } = suburbanInfo;

  return areaText ? (
    <>
      {areaText && (
        <Text textSize="small" color="gray">
          {areaText}
        </Text>
      )}
      {rentTypeText && (
        <div>
          <Text textSize="small" color="gray">
            {rentTypeText}
          </Text>
        </div>
      )}
    </>
  ) : null;
}
